/**
 * @author Ivan Toth.
 * contains edit, cancel, save buttons, that are running the bound functions of their parents
 */
var bindings = { vm: '=', lock: '=' };
var EscButtonController = (function () {
    function EscButtonController(topic, Dialog, settings, env) {
        this.topic = topic;
        this.Dialog = Dialog;
        this.settings = settings;
        this.env = env;
    }
    EscButtonController.prototype.lockComponent = function (event, component, locking) {
        var _this = this;
        this.updateArray = [];
        switch (component) {
            case 'dc':
                this.updateArray = ['dc', 'complcl3'];
                break;
            case 'complcl':
                this.updateArray = ['complcl'];
                break;
            case 'complcl3':
                this.updateArray = ['dc', 'complcl3'];
                break;
            case 'goe':
                this.updateArray = ['goe', 'cmr', 'goe_data', 'fastpass', 'mgr', 'complcl2', 'files$fcmr'];
                break;
            case 'goe_valid':
                this.updateArray = ['goe_valid', 'cmr_valid', 'files$fcmr_valid'];
                break;
            case 'files$general':
                this.updateArray = ['files$general'];
                break;
            case 'files$eligibility':
                this.updateArray = ['files$eligibility'];
                break;
            case 'files$mysa':
                this.updateArray = ['files$mysa'];
                break;
            case 'files$sampling':
                this.updateArray = ['files$sampling'];
                break;
            case 'files$sampling_Solution':
                this.updateArray = ['files$sampling_Solution'];
                break;
            case 'files$sampling_SSA':
                this.updateArray = ['files$sampling_SSA'];
                break;
            case 'complcl_sampling_Solution':
                this.updateArray = ['complcl_sampling_Solution', 'complcl_sampling'];
                break;
            case 'complcl_sampling_SSA':
                this.updateArray = ['complcl_sampling_SSA', 'complcl_sampling'];
                break;
            case 'complcl_sampling':
                this.updateArray = ['complcl_sampling'];
                break;
            case 'customerDesignation':
                this.updateArray = ['customerDesignation'];
                break;
            case 'nc':
                this.updateArray = ['nc'];
                break;
            case 'ctl_so':
                this.updateArray = ['ctl_so'];
                break;
            default:
                this.updateArray = [];
                alert('Unknown component');
                return;
        }
        var items = {
            icon: 'QUESTION',
            cancelMessage: 'Cancel'
        };
        if (locking) {
            items.message = 'Should you choose to continue, you will no longer be able to edit this section. &nbsp;Continue?';
            items.okMessage = 'Lock';
            items.title = 'Lock';
        }
        else {
            items.message = 'Should you choose to continue, this section will become editable once more. &nbsp;Continue?';
            items.okMessage = 'Unlock';
            items.title = 'Unlock';
        }
        this.Dialog.updateValidForm(event, items, 'confirm-prompt.html').then(function (dResult) {
            if (dResult.confirm) {
                var updateObject_1 = {
                    id: _this.topic.topic._id,
                    data: {},
                    type: _this.updateArray,
                    editOption: true
                };
                if (_this.topic.updatePartialSocketStatus(_this.updateArray, 'Updating')) {
                    angular.forEach(_this.updateArray, function (component) {
                        updateObject_1.data['lock_indicator.' + component] = {
                            add: true,
                            data: locking
                        };
                    });
                    //If unlocking Sampling, we'll need to update sampling status, too
                    if (!locking && _this.updateArray.indexOf('complcl_sampling') > -1) {
                        var intensiveType = _this.updateArray.indexOf('complcl_sampling_SSA') > -1
                            ? 'SSA'
                            : (_this.updateArray.indexOf('complcl_sampling_Solution') > -1 ? 'Solution' : undefined);
                        if (intensiveType) {
                            _this.updateArray.push('sampling'); // This object will need refreshing...
                            //Work out what the previous status was
                            var originalStatus = 'In Progress';
                            if (_this.topic.topic.sampling[intensiveType].samplingStatus.indexOf('Manually sampled') > -1) {
                                originalStatus = 'Manually sampled - In Progress';
                            }
                            _this.topic.setTempFromTopicPart('sampling');
                            _this.topic.temp.sampling[intensiveType].samplingStatus = originalStatus;
                            delete _this.topic.temp.sampling[intensiveType].sampTimeEnd;
                            //Add as a field to be updated server-side
                            updateObject_1.data['sampling'] = {
                                add: true,
                                data: _this.topic.temp.sampling
                            };
                        }
                        else {
                            _this.updateArray.push('sampling'); // This object will need refreshing...
                            //Work out what the previous status was
                            var originalStatus = 'In Progress';
                            if (_this.topic.topic.sampling.samplingStatus.indexOf('Manually sampled') > -1) {
                                originalStatus = 'Manually sampled - In Progress';
                            }
                            _this.topic.setTempFromTopicPart('sampling');
                            _this.topic.temp.sampling.samplingStatus = originalStatus;
                            delete _this.topic.temp.sampling.sampTimeEnd;
                            //Add as a field to be updated server-side
                            updateObject_1.data['sampling'] = {
                                add: true,
                                data: _this.topic.temp.sampling
                            };
                        }
                    }
                    _this.topic.updateServerTopic('couchUpdate', updateObject_1, true);
                }
            }
        });
    };
    EscButtonController.$inject = ['topic', 'Dialog', 'settings', 'env'];
    return EscButtonController;
}());
var EscButtonComponent = (function () {
    function EscButtonComponent() {
        this.bindings = bindings;
        this.templateUrl = 'esc-button.html';
        this.controller = EscButtonController;
    }
    return EscButtonComponent;
}());
angular
    .module('application')
    .component('escButtonSection', new EscButtonComponent());

//# sourceMappingURL=detail.escbutton.component.js.map
